/**
 * PAYG Credits A/B test helper (TP-193).
 *
 * Mirrors PaygCreditsTest.php — any logic change must be kept in sync.
 *
 * Variant bucketing: user.id % 2
 *   0 → 'a' (control:   PAYG UI hidden, purchase blocked by API)
 *   1 → 'b' (treatment: PAYG UI fully visible)
 *
 * The test only applies to:
 *   - Signed-in users
 *   - On production: paygCreditsPricingPage toggle on
 *   - On non-production: always active so staging can be verified
 */

import featureToggles from 'featureToggles';

/**
 * Returns the A/B variant for a user, or null if the user is not in the test.
 *
 * @param {object|null} user
 * @returns {'a'|'b'|null}
 */
export const getPaygCreditsVariant = (user) => {
  if (!user?.id) return null;

  if (__CLOUD_ENV__ === 'production') {
    if (!featureToggles.paygCreditsPricingPage) return null;
  }

  return user.id % 2 === 0 ? 'a' : 'b';
};
